import { render, staticRenderFns } from "./DealershipApplicationsLogsList.vue?vue&type=template&id=886f110e"
import script from "./DealershipApplicationsLogsList.vue?vue&type=script&lang=js"
export * from "./DealershipApplicationsLogsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports